module.exports = __webpack_public_path__ + "static/media/ic_promoted_green.82b08cb5.svg";